export const ASIDE_MENU_Z_INDEX = 10;
/** Side panels that slide out from under the sidebar (filters, geofeatures). */
export const SIDE_PANEL_Z_INDEX = ASIDE_MENU_Z_INDEX - 1;
export const DEFAULT_MODAL_Z_INDEX = 1000;
export const OVERLAY_STACK_TOP_Z_INDEX = 10_000;
export const CARD_POPUP_Z_INDEX = 2;
